<template>
    <div class="spinner-page" v-if="isOverviewPageLoading">
        <q-spinner class="spinner" color="primary" size="3em" />
    </div>    
    <div v-else class="uploads-overview-page row justify-center items-center relative-position">
        <div class="status-dropdown">
            <div class="row float-right">
                <p class="status-heading q-mt-sm">Filteren op status:</p>
                <q-select class="status-select"
                          dense
                          v-model="selectedFilter"
                          input-debounce="0"
                          :options="statusOptions"
                          behavior="menu"
                          bg-color="white"
                          outlined />
            </div>
        </div>
        <div class="imports">
            <FilesOverviewCard v-for="(_import) in imports"
                                :key="_import.id"
                                :id="_import.id"
                                :fileName="_import.fileName"
                                :serverFileName="_import.serverFileName"
                                :status="_import.status"
                                :updatedDate="_import.uploadedDateTime"
                                :exception="_import.exception"></FilesOverviewCard>
        </div>        
    </div>
</template>
<script>
    import store from '../store/index.js';
    import { computed, onMounted, watch } from 'vue';
    import FilesOverviewCard from '../components/FilesOverviewCard.vue'
    import ImportsService from '../services/imports.service'
    export default {
        name: 'FilesOverview',
        components: {
            FilesOverviewCard
        },
        setup() {
            onMounted(() => {
                ImportsService.loadStatuses();
                ImportsService.loadImports();
                store.commit('importItems/applySelectedFilter', 'Allemaal');
            });

            const statusOptions = computed({
                get: () => store.state.importItems.importStatuses,
            });

            const imports = computed({
                get: () => store.state.importItems.imports,
            });

            const isOverviewPageLoading = computed({
                get: () => store.state.importItems.isOverviewPageLoading
            });

            const selectedFilter = computed({
                get: () => store.state.importItems.selectedFilter,
                set: (value) => store.commit('importItems/applySelectedFilter', value)
            });

            watch(selectedFilter, (currentFilter, previousFilter) => {                
                if (currentFilter != previousFilter) {
                    ImportsService.filterImports(currentFilter);
                }                
            });

            return {
                statusOptions,
                imports,
                isOverviewPageLoading,
                selectedFilter
            }
        }
    };
</script>